"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ title, children }: LegalPageLayoutProps) {
  const t = useTranslations("Common");

  return (
    <>
      <Header />
      <div className="min-h-screen quant-grid pt-[calc(73px+var(--announcement-bar-height,0px))]">
        <article className="max-w-3xl mx-auto px-6 py-16">
          <Link
            href="/"
            className="inline-block text-slate-400 hover:text-slate-100 text-sm transition-colors mb-8"
          >
            {t("backToHome")}
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-100 mb-12">
            {title}
          </h1>
          <div className="prose prose-invert prose-slate max-w-none space-y-10 text-slate-300">
            {children}
          </div>
        </article>
      </div>
      <Footer />
    </>
  );
}
